import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { restoreCart } from '../actions';

const WaitingPayment = () => {
    const dispatch = useDispatch();
    return (
        <>
            <Row>
                <Col lg={{ span: 6, offset: 3 }} md={12}>
                    <div className="mt-5 text-center">
                        <div className="loading-container spinner-border text-secondary text-center mt-5" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="mt-5 mb-5 text-center text-secondary">
                            <FormattedMessage id="waiting_payment"/>
                        </div>
                        <div className="mt-5 mb-5 text-center text-secondary">
                            <Button variant='primary' onClick={() => dispatch(restoreCart())}>
                                <FormattedMessage id="give_it_up"/>
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};
export default WaitingPayment;
